import React, { useEffect, useState } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  InputGroup,
  InputGroupAddon,
  CustomInput,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Badge,
} from "reactstrap";
import { Link } from "react-router-dom";
import { GrPowerReset } from "react-icons/gr";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { getOfferTypes } from "service/offertype.service";
import { addOffer } from "service/offer.service";
import { addOfferTags } from "service/offerTags.service";
import { addBulkOfferTags } from "service/offerTags.service";
import { updateOffer } from "service/offer.service";
import { getTrackingPanels } from "service/trackingPanel.service";
import { getAdvertisers } from "service/advertiser.service";
import { addOfferTracker } from "service/offerTracker.service";
import { addBulkOfferTracker } from "service/offerTracker.service";
import { getOfferTracker } from "service/offerTracker.service";
import { getOfferTrackerById } from "service/offerTracker.service";
import { updateOfferTracker } from "service/offerTracker.service";
import LoadingSpinner from "layouts/LoadingSpinner/LoadingSpinner";
import { deleteOfferTracker } from "service/offerTracker.service";

const Step2Form = ({formData,
    handleChange,
    handleNextStep,
    handlePreviousStep }) => {
  const [offerData, setFormData] = useState({
    id: 0,
    is_smart_link: false,
    is_event_tracking: false,
    tracking_id: 0,
    user_revenue: 0,
    user_payout: 0,
    offer_user_reward: 0,
    advertiser: "",
    division_rule:'',
    tracking_link: "",
  });
  const [smartLink, setSmartLink] = useState([
    {
        id:0,
      advertiser: "",
      tracking_link: "",
      status: "live",
      revenue: 0,
      payout: 0,
      user_reward: 0,
      total_caps: 0,
      completed_caps: 0,
      click_division: 0,
      time_division: 0,
      offer_id: 0,
      is_smart_link: true,
      tracking_panel: "Offer18",

    },
  ]);
  const [eventTracker, setEventTracker] = useState([
    {
        id:0,
      event_type: "",
      tracking_link: "",
      status: "live",
      revenue: "",
      payout: "",
      user_reward: "",
      total_caps: "",
      completed_caps: "",
      offer_id: 0,
      is_event_tracking: true,
      tracking_panel: "Offer18"
    },
  ]);
  const [tags, setTags] = useState([
    { text: "", textColor: "#ffffff", backgroundColor: "", offerId: 0 },
  ]);

  const [selectedStatus, setSelectedStatus] = useState(
    Array(smartLink.length).fill("Live")
  );
  // setFormData(formData);
  const [step, setStep] = useState(2);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [panelData, setPanelData] = useState([]);
  const [advertiserData, setAdvertiserData] = useState([]);
  const [selectedOption, setSelectedOption] = useState('');
  const [divisionRule, setRuleDivision] = useState("none");
  const [notification, setNotification] = useState(null);
  const [isPreloading, setIsPreLoaded] = useState(true);
  // Handle option selection
  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
    setRuleDivision(e.target.value);

    updateOfferData({division_rule: e.target.value});
  };


  const [dropdownOpen, setDropdownOpen] = useState(
    Array(smartLink.length).fill(false)
  );
  useEffect(() => {
    fetchPanelData();
    fetchAdvertisers();

    console.log(formData);
    setSelectedOption(formData.division_rule);
    setRuleDivision(formData.division_rule);
    // setFormData((prevData) => ({
    //   ...prevData,
    //   ...formData,
    // }));

    setFormData(formData);

    fetchOfferTrackers(formData.id);
  }, [formData]);

  const toggleDropdown = (index) => {
    console.log(index);
    const updatedDropdownOpen = [...dropdownOpen];
    updatedDropdownOpen[index] = !updatedDropdownOpen[index];
    setDropdownOpen(updatedDropdownOpen);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
  };

  const handleStatusChange = async (status, index) => {
    console.log(status, index);
  setIsPreLoaded(true); 
    const updatedStatus = [...selectedStatus];
    updatedStatus[index] = status;
    setSelectedStatus(updatedStatus);

    console.log(selectedStatus);
    // Additional logic specific to the fieldset identified by the index
    const updatedSmartLink = [...smartLink]; // Create a copy of the smartLink array
    updatedSmartLink[index] = { ...updatedSmartLink[index], status }; // Update the status for the specific fieldset

    setSmartLink(updatedSmartLink);
    console.log(smartLink[index]);
    const offerAdded = await updateOfferTracker(smartLink[index].id,{status: status});
      setIsPreLoaded(false);
    // Update the smartLink state with the updated array
  };

  const fetchPanelData = async () => {
    try {
      setIsPreLoaded(true);
      const panels = await getTrackingPanels();
      console.log(panels);
      setPanelData(panels.data.panelFeed);


      if(panels.data.panelFeed.length > 0){
        if(panels.data.panelFeed[0].is_smart_link){

            const data = offerData;
            data.is_smart_link = true;
            setFormData(data);
           setIsPreLoaded(false);

        }

      }
    
    } catch (error) {
      console.error("Error fetching advertisers:", error);
    }
  };

  const  fetchOfferTrackers = async (id) => {
    try {
      setIsPreLoaded(true);
        const panels = await getOfferTrackerById(id);
        console.log(panels);
        console.log(panels.data.offerTrackerFeed.length);
        if(panels.data.offerTrackerFeed.length > 0){
            if(panels.data.offerTrackerFeed[0].is_smart_link){
              const d = offerData;
                d.is_smart_link = true;
                d.id = panels.data.offerTrackerFeed[0].offerId;
                setFormData(d);
                setSmartLink(panels.data.offerTrackerFeed);
            }
            for (let i = 0; i < panels.data.offerTrackerFeed.length; i++) {
                const updatedStatus = [...selectedStatus];
                updatedStatus[i] = panels.data.offerTrackerFeed[i].status;
                setSelectedStatus(updatedStatus);
                renderBadge(i);
                
                
            }
            if(panels.data.offerTrackerFeed[0].is_event_tracking){

            }

            setIsPreLoaded(false);

        }
      
      } catch (error) {
        console.error("Error fetching advertisers:", error);
      }
  }

  const updateOfferData = async (data) => {

    await updateOffer(offerData.id,data);
    setNotification({ type: "success", message: "Offer Status Updated" });
    setTimeout(() => {
      setNotification(null);
    }, 3000); 
  }
  const fetchAdvertisers = async () => {
    try {
      setIsPreLoaded(true);
      const advertisers = await getAdvertisers();
      console.log(advertisers);
      setAdvertiserData(advertisers.data.data.rows);
      setIsPreLoaded(false);
    } catch (error) {
      console.error("Error fetching advertisers:", error);
    }
  };

//   const handleOfferChange = (e) => {
//     const { name, value } = e.target;

//     console.log(e.target);
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value,
//     }));
//   };

//   const handleEditorChange = (value) => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       offer_long_description: value,
//     }));
//   };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const { name, value } = e.target;

    // setFormData((prevData) => ({
    //   ...prevData,
    //   [name]: value,
    // }));
    console.log(offerData);
    console.log(is_smart_link);



    // Simulate an asynchronous submission process
    try {

        if(is_smart_link){
            console.log(smartLink);
            
            //update offer_id in setSmartLink
            
            const d = [...smartLink];
            for (let i = 0; i < smartLink.length; i++) {
                
                d[i].offer_id = offerData.id;
                
            }
            setIsSubmitting(false);
            const offerAdded = await addBulkOfferTracker({offer_id:offerData.id, data:d});
      console.log(offerAdded);
      if (offerAdded.status === 200) {
      
        setIsSubmitting(false);
        setSmartLink(offerAdded.data.result);
        
      }

        }
        if(is_event_tracking){
            console.log(eventTracker);
        }
      
    } catch (error) {
      console.error("Error adding advertiser:", error);
    }
  };
  
  
  const handleUpdateSmartLink = async (index) => {

    setIsSubmitting(true);
 



    // Simulate an asynchronous submission process
    try {

        const avgRevenue = calculateAvgRevenue();
        const avgPayout = calculateAvgPayout();
        const avgUserForm = calculateAvgUserReeward();
        console.log(avgRevenue, avgPayout, avgUserForm);


    

        await updateOffer(offerData.id,{offer_revenue : avgRevenue, offer_payout : avgPayout, offer_user_reward : avgUserForm,  });



      const offerAdded = await updateOfferTracker(smartLink[index].id,smartLink[index]);
      console.log(offerAdded);
      setIsSubmitting(false);
      if (offerAdded.status === 200) {
        setIsSubmitting(false);
        fetchOfferTrackers(offerData.id);

    
      }
    } catch (error) {
      console.error("Error adding advertiser:", error);
    }
  };

  const handleAddNewSmartLink =async (index) =>{

    setIsSubmitting(true);
 
    try{

        const avgRevenue = calculateAvgRevenue();
        const avgPayout = calculateAvgPayout();
        const avgUserForm = calculateAvgUserReeward();

       
        await updateOffer(offerData.id,{offer_revenue : avgRevenue, offer_payout : avgPayout, offer_user_reward : avgUserForm });

        const d = smartLink[index];
        d.offer_id = offerData.id;
      const offerAdded = await addOfferTracker(d);
      console.log(offerAdded);

      if (offerAdded.status === 200) {
        setIsSubmitting(false);
        fetchOfferTrackers(offerData.id);

    
      }
    } catch (error) {
      console.error("Error adding advertiser:", error);
    }

  }

  const calculateAvgRevenue = () => {

        let revenue = 0;
        for (let i = 0; i < smartLink.length; i++) {
           revenue = revenue + parseInt(smartLink[i].revenue);
            
        }
        return Math.floor(revenue/smartLink.length);
  }


  const calculateAvgUserReeward = () => {

    let userReward = 0;
    for (let i = 0; i < smartLink.length; i++) {
       userReward = userReward + parseInt(smartLink[i].user_reward);
        
    }
    return Math.floor(userReward/smartLink.length);
}

  const calculateAvgPayout = () => {

    let payout = 0;
    for (let i = 0; i < smartLink.length; i++) {
       payout = payout + parseInt(smartLink[i].payout);
        
    }
    return Math.floor(payout/smartLink.length);
}

//   const handleBack = () => {
//     setStep((prevStep) => prevStep - 1);
//   };

//   const handleContinue = () => {
//     setStep((prevStep) => prevStep + 1);
//   };
  const handleSmarkLinkChange = (index, field, value) => {
    const updatedTags = [...smartLink];
    updatedTags[index][field] = value;
    setSmartLink(updatedTags);

    
  };
  const handleEventTrackerChange = (index, field, value) => {
    const updatedTags = [...eventTracker];
    updatedTags[index][field] = value;
    setEventTracker(updatedTags);
  };

//   const handleAddTag = () => {
//     setTags([
//       ...tags,
//       { text: "", textColor: "#ffffff", backgroundColor: "#000000" },
//     ]);
//   };
  const handleAddSmartLink = () => {
    setSmartLink([
      ...smartLink,
      {
        id: 0,
        advertiser: "",
        tracking_link: "",
        status: "",
        revenue: 0,
        payout: 0,
        user_reward: 0,
        total_caps: 0,
        completed_caps: 0,
        offer_id: offerData.id,
        time_division: 0,
        click_division:0,
        is_smart_link:true,
        tracking_panel: "Offer18"
      },
    ]);
  };

  const handleAddEventTracker = () => {
    setEventTracker([
      ...eventTracker,
      {
        id: 0,
        event_type: "",
        tracking_link: "",
        status: "",
        revenue: "",
        payout: "",
        user_reward: 0,
        total_caps: "",
        completed_caps: "",
        time_division: 0,
        click_division:0,
        offer_id: offerData.id,
        is_event_tracking:true,
        tracking_panel: "Offer18"
      },
    ]);
  };

  const handleDeleteSmartLink = async(index) => {
    // const updatedTags = [...smartLink];
    // updatedTags.splice(index, 1);
    // setSmartLink(updatedTags);

    console.log(index);
    
    const updatedTags = [...smartLink];
    console.log(updatedTags[index]);

    await deleteOfferTracker(updatedTags[index].id)
    updatedTags.splice(index, 1);
    setSmartLink(updatedTags);


  };

  const handleDeleteEventTracker = (index) => {
    const updatedTags = [...eventTracker];
    updatedTags.splice(index, 1);
    setEventTracker(updatedTags);
  };


  const clearCompletedCaps = (index) => {
    const updatedSmartLink = [...smartLink]; // Create a copy of the smartLink array
    updatedSmartLink[index] = {
      ...updatedSmartLink[index],
      completed_caps: "0",
    }; // Update the status for the specific fieldset

    setSmartLink(updatedSmartLink); // Update the smartLink state with the updated array
  };

  const clearCompletedCapForEvent = (index) => {
    const updatedSmartLink = [...eventTracker]; // Create a copy of the smartLink array
    updatedSmartLink[index] = {
      ...updatedSmartLink[index],
      completed_caps: "0",
    }; // Update the status for the specific fieldset

    setEventTracker(updatedSmartLink); // Update the smartLink state with the updated array
  };

  const renderBadge = (index) => {
    let color = "";
    console.log(selectedStatus);
    switch (selectedStatus[index]) {
      case "live":
        color = "bg-gradient-success";
        break;
      case "paused":
        color = "bg-gradient-warning";
        break;
      case "removed":
        color = "bg-gradient-danger";
        break;
      default:
        color = "bg-gradient-info";
        break;
    }

    return <Badge className={color}>{selectedStatus[index]}</Badge>;
  };

  const { is_smart_link, is_event_tracking } = offerData;

  return (

    <div>

        { 
        isPreloading ?
        (
            <LoadingSpinner />
        ):
        (
   
    <div className="">

    <div>
      {notification && (
        <div className={`notification ${notification.type}`}>
          {notification.message} 
          &nbsp;&nbsp;
          <button type="button" className="btn-close" onClick={() => setNotification(null)}>
            
        </button>
         
        </div>
      )}
    </div>
      <div className="mb-3 d-flex align-items-center justify-content-between">
        <div>Offer Tracking</div>
        {offerData.id > 0 ? (
          <span className="badge badge-success badge-sm my-auto ms-auto me-3 text-dark">
            Offer Id: <strong>{offerData.id}</strong>
          </span>
        ) : null}
      </div>
      <form>
        <fieldset className="custom-fieldset">
          <legend className="custom-legend">Tracking</legend>
          <div className="row">
            <div className="col-md-6">
              <FormGroup>
                <Label for="selectedOption">Tracking Panel</Label>
                <Input
                  type="select"
                  name="tracking_id"
                  id="tracking_id"
                  value={offerData.tracking_id}
                  onChange={handleInputChange}
                >
                  {panelData.map((panel, index) => (
                    <option key={index} value={panel.id}>
                      {panel.tracking_panel_name}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </div>
          </div>
          <div className="row">
            <div className="col-md-4">
              <FormGroup>
                <CustomInput
                  type="switch"
                  id="isLocationTargetting"
                  name="is_smart_link"
                  label="Smart Link"
                  checked={is_smart_link}
                  onChange={() =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      is_smart_link: !prevFormData.is_smart_link,
                      is_event_tracking: false,
                    }))
                  }
                />
              </FormGroup>
            </div>
            <div className="col-md-4">
              <FormGroup>
                <CustomInput
                  type="switch"
                  id="isEventTracking"
                  name="is_event_tracking"
                  label="Event Tracking"
                  checked={is_event_tracking}
                  onChange={() =>
                    setFormData((prevFormData) => ({
                      ...prevFormData,
                      is_event_tracking: !prevFormData.is_event_tracking,
                      is_smart_link: false,
                    }))

                  }
                />
              </FormGroup>
            </div>
          </div>

          {is_smart_link && (
            <div>

<fieldset className="custom-fieldset">
              <legend className="custom-legend">Division Rule</legend>

              <div className="row">
            <div className="col-md-3">
            <FormGroup check>
          <Label check>
            <Input
              type="radio"
              name="option"
              value="click"
              checked={selectedOption === 'click'}
              onChange={handleOptionChange}
            />
            Click Division
          </Label>
        </FormGroup>
            </div>
            <div className="col-md-3">
            <FormGroup check>
          <Label check>
            <Input
              type="radio"
              name="option"
              value="time"
              checked={selectedOption === 'time'}
              onChange={handleOptionChange}
            />
            Time Division
          </Label>
        </FormGroup>
            </div>
            <div className="col-md-3">
            <FormGroup check>
          <Label check>
            <Input
              type="radio"
              name="option"
              value="random"
              checked={selectedOption === 'random'}
              onChange={handleOptionChange}
            />
            Random Division
          </Label>
        </FormGroup>
            </div>
            <div className="col-md-3">
            <FormGroup check>
          <Label check>
            <Input
              type="radio"
              name="option"
              value="none"
              checked={selectedOption === 'none'}
              onChange={handleOptionChange}
            />
            None
          </Label>
        </FormGroup>
            </div>
          </div>
              </fieldset>

              {smartLink.map((node, index) => (
              <div>
                <fieldset
                  className="custom-fieldset mt-3 position-relative"
                  key={index}
                >
                  <a
                    className="btn-close position-absolute top-4 end-2 bg-gradient-danger"
                    style={{
                      padding: "6px 7px",
                      lineHeight: "15px",
                      fontWeight: "700",
                      zIndex: "9999",    
                      paddingLeft: '12px',
                    }}
                    onClick={() => handleDeleteSmartLink(index)}
                  >
                    X
                  </a>
                  <legend className="custom-legend">
                    Smart Link {index + 1}
                  </legend>
                  <div className="row">
                    <div className="col-md-3">
                      <FormGroup>
                        <Label for="name">Advertiser</Label>
                        <Input
                          type="select"
                          name="advertiser"
                          id="advertiser"
                          value={node.advertiser}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "advertiser",
                              e.target.value
                            )
                          }
                        >
                          {advertiserData.map((advertiser, index) => (
                            <option key={index} value={advertiser.shortName}>
                              {advertiser.name}({advertiser.shortName})
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </div>
                    <div className="col-md-7">
                      <FormGroup>
                        <Label for="email">Tracking Link</Label>
                        <Input
                          type="text"
                          name="tracking_link"
                          id="tracking_link"
                          placeholder="Tracking link..."
                          value={node.tracking_link}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "tracking_link",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="name">Status</Label>
                        <div>
                          <Dropdown
                            isOpen={dropdownOpen[index]}
                            toggle={() => toggleDropdown(index)}
                            onChange={(e) =>
                              handleSmarkLinkChange(
                                index,
                                "status",
                                e.target.value
                              )
                            }
                          >
                            <DropdownToggle
                              caret
                              className="custom-dropdown-toggle"
                            >
                              {renderBadge(index)}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() =>
                                  handleStatusChange("live", index)
                                }
                              >
                                Live
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  handleStatusChange("paused", index)
                                }
                              >
                                Paused
                              </DropdownItem>
                           
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Revenue</Label>
                        <Input
                          type="number"
                          name="revenue"
                          id="revenue"
                          placeholder="100"
                          value={node.revenue}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "revenue",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Payout</Label>
                        <Input
                          type="number"
                          name="payout"
                          id="payout"
                          placeholder="100"
                          value={node.payout}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "payout",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">User Coins</Label>
                        <Input
                          type="number"
                          name="user_reward"
                          id="user_reward"
                          placeholder="100"
                          value={node.user_reward}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "user_reward",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Total Caps</Label>
                        <Input
                          type="number"
                          name="total_caps"
                          id="total_caps"
                          placeholder="100"
                          value={node.total_caps}
                          onChange={(e) =>
                            handleSmarkLinkChange(
                              index,
                              "total_caps",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="selectedOption">Completed Caps</Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="completed_caps"
                            id="completed_caps"
                            placeholder="100"
                            value={node.completed_caps}
                            disabled={true}
                            onChange={(e) =>
                              handleSmarkLinkChange(
                                index,
                                "completed_caps",
                                e.target.value
                              )
                            }
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="light"
                              onClick={() => clearCompletedCaps(index)}
                            >
                              <GrPowerReset color="white" />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </div>

                    { divisionRule === "click" ? (
                        <div className="col-md-2">
                        <FormGroup>
                          <Label for="email">Click Division</Label>
                          <Input
                            type="number"
                            name="click_division"
                            id="click_division"
                            placeholder="100"
                            value={node.click_division}
                            onChange={(e) =>
                              handleSmarkLinkChange(
                                index,
                                "click_division",
                                e.target.value
                              )
                            }
                          />
                        </FormGroup>
                      </div>
                    ) : (null)}

                    { divisionRule === "time" ? (
                       <div className="col-md-2">
                       <FormGroup>
                         <Label for="email">Time Division</Label>
                         <Input
                           type="number"
                           name="time_division"
                           id="time_division"
                           placeholder="100"
                           value={node.time_division}
                           onChange={(e) =>
                             handleSmarkLinkChange(
                               index,
                               "time_division",
                               e.target.value
                             )
                           }
                         />
                       </FormGroup>
                     </div>
                    ): (null)}
                  
                   
                  </div>
                  { node.id === 0 && (
                    <div className="row">
                    <div className="col-md-2">

                    
                    <Button className="btn btn-xs bg-gradient-primary"
                    onClick={() => handleAddNewSmartLink(index)}
                    >
                         <i class="fas fa-plus pe-2" aria-hidden="true"></i> Add
                    </Button>
                    </div>
                    </div>
                  )}
                 
                  { offerData.id > 0 && node.id > 0 && (
                     <div className="row">
                    
                            <div className="col-md-2">
 
                         <Button className="btn btn-xs bg-gradient-primary"
                         onClick={() => handleUpdateSmartLink(index)}
                         >
                             Update
                         </Button>
                         </div>
                         </div>
                  )}
            
                   
                </fieldset>
                </div>
              ))}

              <div className="mt-3">
                <Button
                  type="button"
                  onClick={handleAddSmartLink}
                  className="btn btn-xs btn-primary mb-0"
                  color="primary"
                >
                  <i class="fas fa-plus pe-2" aria-hidden="true"></i> Add smart
                  link
                </Button>
              </div>
            </div>
          )}

        <div>
        {is_event_tracking && (
        <div>
              {eventTracker.map((node, index) => (
                <fieldset
                  className="custom-fieldset mt-3 position-relative"
                  key={index}
                >
                  <button
                    className="btn-close position-absolute top-4 end-2 bg-gradient-danger"
                    style={{
                      padding: "6px 7px",
                      lineHeight: "10px",
                      fontWeight: "700",
                      zIndex: "9999",
                    }}
                    onClick={() => handleDeleteEventTracker(index)}
                  >
                    X
                  </button>
                  <legend className="custom-legend">
                    Event Tracker {index + 1}
                  </legend>
                  <div className="row">
                    <div className="col-md-3">
                      <FormGroup>
                        <Label for="name">Event Type</Label>
                        <Input
                          type="text"
                          name="event_type"
                          id="advertiser"
                          placeholder="install"
                          value={node.event_type}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "event_type",
                              e.target.value
                            )
                          }
                        />
                        
                    
                      </FormGroup>
                    </div>
                    <div className="col-md-7">
                      <FormGroup>
                        <Label for="email">Tracking Link</Label>
                        <Input
                          type="text"
                          name="tracking_link"
                          id="tracking_link"
                          placeholder="Tracking link..."
                          value={node.tracking_link}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "tracking_link",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="name">Status</Label>
                        <div>
                          <Dropdown
                            isOpen={dropdownOpen[index]}
                            toggle={() => toggleDropdown(index)}
                            onChange={(e) =>
                                handleEventTrackerChange(
                                index,
                                "status",
                                e.target.value
                              )
                            }
                          >
                            <DropdownToggle
                              caret
                              className="custom-dropdown-toggle"
                            >
                              {renderBadge(index)}
                            </DropdownToggle>
                            <DropdownMenu>
                              <DropdownItem
                                onClick={() =>
                                  handleStatusChange("live", index)
                                }
                              >
                                Live
                              </DropdownItem>
                              <DropdownItem
                                onClick={() =>
                                  handleStatusChange("paused", index)
                                }
                              >
                                Paused
                              </DropdownItem>
                              
                            </DropdownMenu>
                          </Dropdown>
                        </div>
                      </FormGroup>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Revenue</Label>
                        <Input
                          type="number"
                          name="revenue"
                          id="revenue"
                          placeholder="100"
                          value={node.revenue}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "revenue",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Payout</Label>
                        <Input
                          type="number"
                          name="payout"
                          id="payout"
                          placeholder="100"
                          value={node.payout}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "payout",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">User Coins</Label>
                        <Input
                          type="number"
                          name="user_reward"
                          id="user_reward"
                          placeholder="100"
                          value={node.user_reward_amount}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "user_reward",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="email">Total Caps</Label>
                        <Input
                          type="number"
                          name="total_caps"
                          id="total_caps"
                          placeholder="100"
                          value={node.total_caps}
                          onChange={(e) =>
                            handleEventTrackerChange(
                              index,
                              "total_caps",
                              e.target.value
                            )
                          }
                        />
                      </FormGroup>
                    </div>
                    <div className="col-md-2">
                      <FormGroup>
                        <Label for="selectedOption">Completed Caps</Label>
                        <InputGroup>
                          <Input
                            type="number"
                            name="completed_caps"
                            id="completed_caps"
                            placeholder="100"
                            value={node.completed_caps}
                            onChange={(e) =>
                              handleEventTrackerChange(
                                index,
                                "completed_caps",
                                e.target.value
                              )
                            }
                          />
                          <InputGroupAddon addonType="append">
                            <Button
                              color="light"
                              onClick={() => clearCompletedCapForEvent(index)}
                            >
                              <GrPowerReset color="white" />
                            </Button>
                          </InputGroupAddon>
                        </InputGroup>
                      </FormGroup>
                    </div>
                  </div>
                </fieldset>
              ))}

              <div className="mt-3">
                <Button
                  type="button"
                  onClick={handleAddEventTracker}
                  className="btn btn-xs btn-primary mb-0"
                  color="primary"
                >
                  <i class="fas fa-plus pe-2" aria-hidden="true"></i>Event Tracker
                </Button>
              </div>
            </div>
                  )}
        </div>
  
        </fieldset>

        <div className="d-flex justify-content-between mt-3">
          {step > 1 && (
            <Button type="button" color="secondary" onClick={handlePreviousStep}>
              Back
            </Button>
          )}
        
          {step === 2 && (
            <Button type="submit" color="primary" disabled={isSubmitting} onClick={handleNextStep}>
              {isSubmitting ? <Spinner size="sm" color="light" /> : "Submit & Next"}
            </Button>
          )}
        </div>
      </form>
    </div>
        )}
      </div>
  
  );
};

export default Step2Form;
